module.exports = new __parcel__URL__("nasa-graphics-standards-manual.130d17ac.jpg").toString();